<template>
  <section v-if="student_person_id !== null">
    <DataReportCard
      :student_person_id="student_person_id"
      :isAdmin="true"
    ></DataReportCard>
  </section>
</template>
<script>
import DataReportCard from "@/entities/grades/DataReportCard";

export default {
  name: "StudentReportCard",
  components: {
    DataReportCard,
  },
  data() {
    return {
      student_person_id: null,
    };
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  mounted() {
    const { person_id } = this.$route.params;
    this.student_person_id = parseInt(person_id);
  },
};
</script>